export default "__VITE_ASSET__CsNDcMbo__"